import React, { Component } from 'react'
import { Button } from 'components/UI/Button'
import { ButtonsBlock } from 'components/common'

// tslint:disable-next-line:no-empty-interface
interface Props {
  currentStep?: number
  pages?: any
  nextPage?: any
  prevPage?: any
  onSubmit: any
  onCancel: any
  onPrevPage: any
  onNextPage: any
}

class FormButtons extends Component<Props> {
  render() {
    const {
      onSubmit,
      onCancel,
      onPrevPage,
      onNextPage,
      pages,
      currentStep
    } = this.props

    if (currentStep || currentStep === 0) {
      return (
        <ButtonsBlock>
          {currentStep === 0 ? (
            <Button variant={'secondary'} onClick={onCancel}>
              Cancel Estimate
            </Button>
          ) : (
            <Button variant={'secondary'} onClick={onPrevPage}>
              Back
            </Button>
          )}

          {currentStep === pages.length - 1 ? (
            <Button variant={'default'} onClick={onSubmit}>
              Generate estimate
            </Button>
          ) : (
            <Button variant={'default'} onClick={onNextPage}>
              Next
            </Button>
          )}
        </ButtonsBlock>
      )
    }

    return (
      <ButtonsBlock>
        <Button variant={'secondary'} onClick={onCancel}>
          Cancel
        </Button>

        <Button variant={'default'} onClick={onSubmit}>
          Save
        </Button>
      </ButtonsBlock>
    )
  }
}

export default FormButtons
